/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { RESOURCE_MODULE_IDS } from "config/constants";
import { useEffect, useState } from "react";
//#endregion
//#region Utils
import { INIT_FILTERS } from "../constants";
//#endregion

const useFilters = ({
    data: { resourceModuleList },
    isUniqueCampus
}) => {
    //#region States
    const [filters, setFilters] = useState({ ...INIT_FILTERS });
    //#endregion
    useEffect(() => {
        presetResourceModuleIdIfThereIsOnlyOneOption();
    }, [resourceModuleList]);
    //#region Functions
    function presetResourceModuleIdIfThereIsOnlyOneOption() {
        if (isUniqueResourceModule())
            setResourceModuleId(resourceModuleList[0].id);
    }
    const setFilter = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    }
    function isUniqueResourceModule() {
        return resourceModuleList.length === 1;
    }
    const clearFilters = () => {
        const resourceModuleId = isUniqueResourceModule() ? filters.resourceModuleId : INIT_FILTERS.resourceModuleId;
        setFilters({ ...INIT_FILTERS, resourceModuleId });
    }
    const filtersAreCompleted = () => {
        const {
            campusId, resourceModuleId,
            libraryId, resourceTypeId,
            spaceTypeId, spaceId
        } = filters;
        let completed = Boolean(
            campusId > 0 && resourceModuleId > 0
        );
        switch (resourceModuleId) {
            case RESOURCE_MODULE_IDS.LIBRARY:
                completed = Boolean(
                    completed && libraryId > 0 &&
                    resourceTypeId);
                break;
            case RESOURCE_MODULE_IDS.UNIVERSITY_SPACES:
                completed = Boolean(
                    completed && spaceTypeId > 0 &&
                    spaceId > 0);
                break;
            default: break;
        }
        return completed;
    }
    function setCampusId(value) {
        setFilter("campusId", value);
    }
    function setResourceModuleId(value) {
        setFilter("resourceModuleId", value);
        clearFieldsAccordsResourceModuleSelected(value);
    }
    const setResourceTypeId = value => {
        setFilter("resourceTypeId", value);
    }
    function setLibraryId(value) {
        setFilter("libraryId", value);
    }
    function setSpaceTypeId(value) {
        setFilter("spaceTypeId", value);
        if (filters.spaceTypeId !== value)
            setSpaceId(0);
    }
    function setSpaceId(value) {
        setFilter("spaceId", value);
    }
    function clearUniversitySpaceFields() {
        setSpaceTypeId(0);
        setSpaceId(0);
    }
    function clearLibraryFields() {
        setLibraryId(0);
        setResourceTypeId("");
    }
    function clearFieldsAccordsResourceModuleSelected(value) {
        switch (value) {
            case RESOURCE_MODULE_IDS.LIBRARY:
                clearUniversitySpaceFields();
                return;
            case RESOURCE_MODULE_IDS.UNIVERSITY_SPACES:
                clearLibraryFields();
                return;
            default:
                return;
        }
    }
    //#endregion
    return {
        value: filters,
        change: setFilter,
        setCampusId, setResourceModuleId,
        setResourceTypeId, setLibraryId,
        setSpaceTypeId, setSpaceId,
        clear: clearFilters,
        areCompleted: filtersAreCompleted,
        isUniqueCampus
    };
}

export default useFilters;